import { DependencyList, useEffect } from 'react'

const useEffectLoopInterval = (fn: (intervalID) => void, option: {
  easeIntervals?: number
  msInterval: number
}, dependencies?: DependencyList) => {
  useEffect(() => {
    let intervalId
    intervalId = setInterval(() => {
      fn(intervalId)
    }, option.msInterval)

    return () => {
      clearInterval(intervalId)
      if (option.easeIntervals) {
        let easeIntervalsCount = 0
        intervalId = setInterval(() => {
          fn(intervalId)
          easeIntervalsCount += 1
          if (easeIntervalsCount > option.easeIntervals!) {
            clearInterval(intervalId)
          }
        }, option.msInterval)
      }
    }
  // Disabling rule due to the spread-operator. ¯\_(ツ)_/¯
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fn, option.easeIntervals, option.msInterval, ...(dependencies || [])])
}
export default useEffectLoopInterval
